"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIEmitValueEvents = void 0;
function isIEmitValueEvents(value) {
    if (typeof value.emitValueEvent !== "function") {
        return false;
    }
    return true;
}
exports.isIEmitValueEvents = isIEmitValueEvents;
//# sourceMappingURL=IEmitValueEvents.js.map